module.exports = __webpack_public_path__ + "img/main-logo.6343aaaa.png";